import { create } from "zustand"

import "../graphql/salesOpportunityQueries"
import type { SalesOpportunitySearchParams } from "../schemas"

import {
  GetSalesOpportunityListDocument,
  type GetSalesOpportunityListQuery,
  type SalesPipeline,
} from "@/graphql/codegen/graphql"
import { createSearchStore } from "@/stores/createSearchStore"

export const deduplicateSalesOpportunities = (
  newData: SalesPipeline[],
  existingData: SalesPipeline[]
): SalesPipeline[] => {
  const seen = new Set(existingData.map((salesOpportunity) => salesOpportunity.id))
  return [...existingData, ...newData.filter((salesOpportunity) => !seen.has(salesOpportunity.id))]
}

export const useSalesOpportunitySearchStore = create(
  createSearchStore<SalesPipeline, SalesOpportunitySearchParams, GetSalesOpportunityListQuery>({
    documentNode: GetSalesOpportunityListDocument,
    deduplicateData: deduplicateSalesOpportunities,
    getQueryInput: (filters, offset, limit) => {
      const { field, order, query, companyIds, createdByUserIds, statuses, quoteDateFrom, quoteDateTo } = filters
      const quoteDateRange = quoteDateFrom ? { start: quoteDateFrom, end: quoteDateTo } : undefined
      return {
        offset,
        limit,
        sort: field && order ? { field, order } : undefined,
        filter: {
          query,
          companyIds,
          createdByUserIds,
          statuses,
          quoteDateRange,
        },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.salesPipeline.list.__typename,
      data:
        data.salesPipeline.list.__typename === "SalesPipelineListSuccess"
          ? (data.salesPipeline.list.salesPipelines as SalesPipeline[])
          : [],
      error:
        data.salesPipeline.list.__typename === "SalesPipelineListFailure" ? data.salesPipeline.list.error : undefined,
    }),
    hasMoreData: (response, state) => response.data.length === state.limit,
  })
)
